import type { IComponentController } from "angular";

export default class InputMultiselectDirectiveController implements IComponentController {
    public static $inject: string[] = ["$element"];

    constructor(private readonly $element: JQuery) {}

    public blur() {
        const uiSelect = this.$element.find(".ui-select-multiple");

        uiSelect.blur();
    }
}
